export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Электрондық чекті белсендіру"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Депозиттік шот"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сан"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сериялар"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Белсендіру коды"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тексеру"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Іске қосу"])}
}